export const G_listResolutions = new Map([
  ["xxl", 1400],
  ["xl", 1200],
  ["lg", 992],
  ["md", 768],
  ["sm", 576],
  ["all", 0],
]);
